import { render } from "./EditarGrupos.vue?vue&type=template&id=706fc076"
import script from "./EditarGrupos.vue?vue&type=script&lang=js"
export * from "./EditarGrupos.vue?vue&type=script&lang=js"

import "./EditarGrupos.vue?vue&type=style&index=0&id=706fc076&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__